import cloneDeep from 'lodash.clonedeep';
import omit from 'lodash.omit';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateSensitivePropertyGroupName =
  (prevName: string, newName: string) => (model: Model) => {
    // usually harmless, but otherwise this might delete value in originalSpgNamesByCurrentName
    if (prevName === newName) {
      return;
    }

    const existingAttributeIris =
      model.modelData.sensitivePropertyGroupsByName[prevName];

    if (!existingAttributeIris) {
      return;
    }

    setDataProperty<ModelData>(model)(
      model.modelData,
      'sensitivePropertyGroupsByName',
      {
        ...omit(model.modelData.sensitivePropertyGroupsByName, prevName),
        [newName]: [...existingAttributeIris],
      }
    );

    if (model.modelData.draftData) {
      const draftData = cloneDeep(model.modelData.draftData);
      const originalName = draftData.originalSpgNamesByCurrentName[prevName];
      if (originalName) {
        if (originalName !== newName) {
          draftData.originalSpgNamesByCurrentName[newName] = originalName;
        }
        delete draftData.originalSpgNamesByCurrentName[prevName];
      }

      setDataProperty<ModelData>(model)(
        model.modelData,
        'draftData',
        draftData
      );
    }
  };
